import { render, staticRenderFns } from "./PasswordResetCompletion.vue?vue&type=template&id=5224d049&scoped=true&"
import script from "./PasswordResetCompletion.vue?vue&type=script&lang=ts&"
export * from "./PasswordResetCompletion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5224d049",
  null
  
)

export default component.exports